import React     from 'react';
import _         from 'lodash'
import numeral   from 'numeral';
import PropTypes from 'prop-types'

const priceCompare = (a, b) => {
  if (!a || !b) return false;

  return a.quantity === b.quantity &&
    a.total === b.total &&
    a.lead_time === b.lead_time &&
    a.product_key === b.product_key &&
    a.quote_config_key === b.quote_config_key
}

class PriceMatrixCell extends React.Component {
  constructor(props) {
    super(props);
    this.unitPrice = this.unitPrice.bind(this);
    this.showText = this.showText.bind(this);
    this.cellClass = this.cellClass.bind(this);
    this.showUnitPrice = this.showUnitPrice.bind(this);
    this.isInCombined = this.isInCombined.bind(this);
  }

  unitPrice() {
    const {price} = this.props
    if (price.total === undefined) return null;

    const up = price.total / this.props.quantity;
    return Math.round(up * 100) / 100;
  }

  showUnitPrice() {
    const unitPrice = this.unitPrice()
    if (unitPrice === null) return ''

    return `$${numeral(unitPrice)
      .format('0.00')}`;
  }

  showText() {
    const {price} = this.props
    if (!price || !price.total) {
      return '\u00A0';
    }
    return this.showUnitPrice();
  }

  isInCombined() {
    const {price, usCombined} = this.props
    if (!price || !usCombined) return false;

    const target = _.get(usCombined, ['matrix', this.props.quantity.toString(), this.props.groupName, this.props.leadTime.toString()])
    return priceCompare(price, target);
  }

  cellClass() {
    const {price} = this.props
    if (!price || !price.quote_config_key) return '';

    let klass = [];

    klass.push(_.endsWith(price.quote_config_key, '-grpa') ? 'best-price' : 'customer-price');

    if (this.isInCombined()) {
      klass.push('fw-bold')
    }

    return _.join(klass, ' ')
  }

  render() {
    return <td className={this.cellClass()}>{this.showText()}</td>;
  }
}

PriceMatrixCell.propTypes = {
  groupName: PropTypes.string.isRequired,
  price: PropTypes.object.isRequired,
  quantity: PropTypes.number.isRequired,
  usCombined: PropTypes.object.isRequired,
  leadTime: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
}

export default PriceMatrixCell;
